/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
// Generated on 2025-04-09T11:57:05-05:00
export const LocationValidateDocument = gql `
    query locationValidate($location: StructuredLocationInput!, $language: LanguageCode!) {
  validateLocation(input: {location: $location, language: $language}) {
    location {
      latitude
      longitude
      aliases {
        alias
        languageCode
      }
      ancestors {
        aliases {
          alias
          languageCode
        }
        canonicalName
        code
        latitude
        longitude
        locationPrecisionKilometers
        locationType
      }
      canonicalName
      code
      locationPrecisionKilometers
      locationType
    }
    formattedName
  }
}
    `;
/**
 * __useLocationValidateQuery__
 *
 * To run a query within a React component, call `useLocationValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationValidateQuery({
 *   variables: {
 *      location: // value for 'location'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useLocationValidateQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(LocationValidateDocument, options);
}
export function useLocationValidateLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(LocationValidateDocument, options);
}
export function useLocationValidateSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(LocationValidateDocument, options);
}
export const LocationInputComponentStringPrefillDocument = gql `
    query locationInputComponentStringPrefill($location: String!, $country: CountryCode!, $language: LanguageCode!, $preciseLocation: Boolean!) {
  locationInputComponentStringPrefill(
    input: {location: $location, country: $country, language: $language, preciseLocation: $preciseLocation}
  ) {
    location {
      latitude
      longitude
      aliases {
        alias
        languageCode
      }
      ancestors {
        aliases {
          alias
          languageCode
        }
        canonicalName
        code
        latitude
        longitude
        locationPrecisionKilometers
        locationType
      }
      canonicalName
      code
      locationPrecisionKilometers
      locationType
    }
    formattedName
  }
}
    `;
/**
 * __useLocationInputComponentStringPrefillQuery__
 *
 * To run a query within a React component, call `useLocationInputComponentStringPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationInputComponentStringPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationInputComponentStringPrefillQuery({
 *   variables: {
 *      location: // value for 'location'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      preciseLocation: // value for 'preciseLocation'
 *   },
 * });
 */
export function useLocationInputComponentStringPrefillQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(LocationInputComponentStringPrefillDocument, options);
}
export function useLocationInputComponentStringPrefillLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(LocationInputComponentStringPrefillDocument, options);
}
export function useLocationInputComponentStringPrefillSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(LocationInputComponentStringPrefillDocument, options);
}
export const LocationAutocompleteDocument = gql `
    query locationAutocomplete($searchText: String!, $country: CountryCode!, $language: LanguageCode!, $useIp: Boolean, $maxResults: Int, $locationTypeFilter: [LocationType!], $exactMatchOnly: Boolean) {
  locationAutocomplete(
    input: {searchText: $searchText, country: $country, language: $language, useIp: $useIp, maxResults: $maxResults, locationTypeFilter: $locationTypeFilter, exactMatchOnly: $exactMatchOnly}
  ) {
    location {
      ancestors {
        locationType
        code
        canonicalName
        aliases {
          languageCode
          alias
        }
        latitude
        longitude
        locationPrecisionKilometers
      }
      locationType
      code
      canonicalName
      latitude
      longitude
      locationPrecisionKilometers
      aliases {
        alias
        languageCode
      }
    }
    formattedName
  }
}
    `;
/**
 * __useLocationAutocompleteQuery__
 *
 * To run a query within a React component, call `useLocationAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationAutocompleteQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      country: // value for 'country'
 *      language: // value for 'language'
 *      useIp: // value for 'useIp'
 *      maxResults: // value for 'maxResults'
 *      locationTypeFilter: // value for 'locationTypeFilter'
 *      exactMatchOnly: // value for 'exactMatchOnly'
 *   },
 * });
 */
export function useLocationAutocompleteQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(LocationAutocompleteDocument, options);
}
export function useLocationAutocompleteLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(LocationAutocompleteDocument, options);
}
export function useLocationAutocompleteSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(LocationAutocompleteDocument, options);
}
/* eslint-enable */
//# sourceMappingURL=data:application/json;base64,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